module.exports = __webpack_public_path__ + "img/zoosk.c028dac.png";